"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isActiveServer = exports.initOidcProviderConfig = exports.initOidcIdentityProviderStatus = exports.initOidcData = exports.getIdentityID = void 0;
var _uuid = require("uuid");
var _globalStates = require("../../globalstates/globalStates");
var getIdentityID = exports.getIdentityID = function getIdentityID(accessURL) {
  return "".concat(accessURL, "/auth/realms/userful");
};
var initOidcIdentityProviderStatus = exports.initOidcIdentityProviderStatus = function initOidcIdentityProviderStatus(accessURL) {
  return {
    provider: {
      id: {
        value: ""
      },
      config: [{
        id: {
          value: (0, _uuid.v4)()
        },
        displayName: "",
        syncMode: "FORCE",
        alias: "",
        type: "PING_SSO",
        clientId: "",
        clientSecret: "",
        entityId: getIdentityID(accessURL),
        discoveryUrl: ""
      }, {
        id: {
          value: (0, _uuid.v4)()
        },
        displayName: "",
        syncMode: "FORCE",
        alias: "",
        type: "PING_SSO",
        clientId: "",
        clientSecret: "",
        entityId: "",
        discoveryUrl: ""
      }],
      enabled: false
    },
    error: false,
    errorMassage: "",
    errorKey: "NONE"
  };
};
var initOidcProviderConfig = exports.initOidcProviderConfig = function initOidcProviderConfig() {
  return {
    id: {
      value: (0, _uuid.v4)()
    },
    displayName: "",
    syncMode: "FORCE",
    alias: "",
    type: "PING_SSO",
    clientId: "",
    clientSecret: "",
    entityId: "",
    discoveryUrl: ""
  };
};
var initOidcData = exports.initOidcData = function initOidcData() {
  return {
    providers: []
  };
};
var isActiveServer = exports.isActiveServer = function isActiveServer(redirectURL) {
  if (redirectURL === "") {
    return false;
  }
  var activeAccessURL = (0, _globalStates.getGlobalStates)().host;
  return redirectURL.indexOf(activeAccessURL) >= 0;
};